export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
export const GMAIL_REGEX = EMAIL_REGEX;
export const INDIAN_MOBILE_REGEX = /^[6-9]\d{9}$/;

export function normalizeEmail(value) {
  return String(value || "").trim().toLowerCase();
}

export function normalizeIndianPhone(value) {
  const digits = String(value || "").replace(/\D/g, "");
  if (digits.length === 12 && digits.startsWith("91")) {
    return digits.slice(2);
  }
  return digits;
}

export function isValidGmail(value) {
  return EMAIL_REGEX.test(normalizeEmail(value));
}

export function isValidEmail(value) {
  return EMAIL_REGEX.test(normalizeEmail(value));
}

export function isValidIndianMobile(value) {
  return INDIAN_MOBILE_REGEX.test(normalizeIndianPhone(value));
}
